import { ColumnDataType, Provider, WorkflowComponentParamType, WorkflowComponentParameterMode } from '../types';
import { addColumn } from '../utils/schemas';
import { SelectWorkflowComponent } from './common/selectcomponent';
class QuadbinFromPoint extends SelectWorkflowComponent {
    constructor() {
        super({
            name: 'native.quadbinfrompoint',
            group: 'Spatial Indexes',
            title: 'Quadbin from GeoPoint',
            description: `
      This component adds a new column containing the indices of Quadbin cells corresponding to points.
      `,
            starred: true
        }, [
            {
                name: 'source',
                type: WorkflowComponentParamType.InputTable,
                title: 'Source table'
            },
            {
                name: 'pointscol',
                type: WorkflowComponentParamType.Column,
                title: 'Points column',
                parent: 'source',
                dataType: [ColumnDataType.Geography, ColumnDataType.Geometry]
            },
            {
                name: 'resolution',
                type: WorkflowComponentParamType.Number,
                title: 'Resolution',
                min: 0,
                max: 26,
                default: 12,
                mode: WorkflowComponentParameterMode.Slider
            }
        ]);
    }
    getInnerSql({ params, connection, envVars }) {
        if (connection.type === Provider.DatabricksRest) {
            return `SELECT /*+ REPARTITION(40) */
              QUADBIN_FROMGEOGPOINT(
                ST_ASTEXT(${connection.processInputGeogColumn(params.pointscol)}),
                ${params.resolution}
              ) quadbin, *
              FROM ${connection.quoteName(params.source)}`;
        }
        else {
            return `SELECT
              ${connection.quoteName(envVars.analyticsToolboxDataset)}.QUADBIN_FROMGEOGPOINT(
                ${params.pointscol},
                ${params.resolution}
              ) quadbin, *
              FROM ${connection.quoteName(params.source)}`;
        }
    }
    requiredAnalyticsToolboxVersion(provider) {
        return '1.0.0';
    }
    canProvideOutputSchemas() {
        return true;
    }
    getOutputSchema({ columns }) {
        return addColumn(columns.source, {
            name: 'quadbin',
            type: ColumnDataType.Number
        });
    }
}
export { QuadbinFromPoint };
